var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_-_witness",
    "data-name": "Ico - witness",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 36,
    height: 36,
    transform: "translate(0 0)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9639",
    "data-name": "Trazado 9639",
    d: "M2.336,13.806c4.093,10.323,18.891,10.29,23.026,0a12.456,12.456,0,0,0-23.026,0ZM13.849,19.8a5.83,5.83,0,0,1-5.932-5.973A5.961,5.961,0,1,1,13.849,19.8Zm0-10.281a4.16,4.16,0,0,0-4.268,4.309c-.072,5.465,8.294,5.938,8.576,0a4.309,4.309,0,0,0-4.309-4.309Zm2.138,5.141a.829.829,0,0,1-.832-.832,1.314,1.314,0,0,0-1.306-1.306.832.832,0,0,1,0-1.664,2.972,2.972,0,0,1,2.97,2.97.835.835,0,0,1-.832.832ZM13.849,25.468a.833.833,0,0,1-.832-.832V23.143a.832.832,0,1,1,1.664,0v1.492a.833.833,0,0,1-.832.832Zm4.8-.964h0a.827.827,0,0,1-.588-.243L17.01,23.2h0a.831.831,0,0,1,1.176-1.176l1.055,1.055a.837.837,0,0,1-.588,1.42Zm-9.608,0h0a.837.837,0,0,1-.588-1.42l1.055-1.055A.832.832,0,0,1,10.687,23.2c-.448.382-1.133,1.362-1.643,1.3ZM17.6,5.861a.837.837,0,0,1-.588-1.42l1.055-1.055h0a.832.832,0,0,1,1.176,1.177c-.449.382-1.133,1.361-1.643,1.3Zm-7.5,0h0a.828.828,0,0,1-.588-.244L8.457,4.562A.832.832,0,0,1,9.632,3.385l1.056,1.056a.838.838,0,0,1-.589,1.42Zm3.748-.528a.831.831,0,0,1-.832-.832V3.009a.832.832,0,0,1,1.664,0V4.5a.831.831,0,0,1-.832.832Z",
    transform: "translate(4.787 4.178)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWitness);
export default __webpack_public_path__ + "static/media/icon-witness.e1f10e9ff5e524836658957454b8caa2.svg";
export { ForwardRef as ReactComponent };